module.exports = __webpack_public_path__ + "static/media/blog-logo-fintrux.45b2301e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/blog-logo-fintrux.png
// module id = 688
// module chunks = 0